<template>
    <div id="six" class="mb-5"  ref="recommendContainer" v-if="currentShow">
        <div class="container">
            <div class="title-line" v-if="!isLoading">
                <h4 class="title-text" v-text="title"></h4>
                <a href="article" class="title-button btn btn-lg more" role="button" aria-pressed="true" title="">更多文章</a>
            </div>
            <div class="spinner-border text-primary" role="status" v-if="isLoading">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="row" v-if="!isLoading">
                    <div class="col-lg-12 col-md-6 mb-5" v-for="item in recommends" :key="item.id">
                        <index-note-component
                            :page-name="'homePage'"
                            :page-position="'hotArticle'"
                            :note="item"
                            :post-at="formatDate(item.postAt)"
                            :favorite-added="item.favoriteAdded ? true : false"
                            :note-id="item.id"
                            :type-id-spec-id-key="item.typeIdSpecIdKey"
                        ></index-note-component>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import IndexNoteComponent from 'Vue/Web/Common/IndexNoteComponent';

export default {
    name: 'HomePageNoteComponent',
    components: {
        IndexNoteComponent,
    },
    props: {
        ids: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        show: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        title: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '熱門文章',
        },
    },
    data() {
        return {
            currentShow: false,
            isLoading: true,
            recommends: [],
            url: '/api/getHomePageHotNote',
        };
    },
    beforeMount() {
        this.currentShow = !!(this.ids || this.show);
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    computed: {},
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 20% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.currentShow) {
                        this.getResult();
                        observer.unobserve(this.$refs.recommendContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.recommendContainer) {
                observer.observe(this.$refs.recommendContainer);
            }
        },
        initOwlCarousel() {
            $(this.$refs.carousel)
                .owlCarousel({
                    autoplay: false, // 自動撥放
                    loop: false, // 圖片循環
                    center: false, // 是否置中
                    navText: [], // 箭頭預設文字消失
                    nav: true, // 前後箭頭
                    dot: true,
                    responsive: {
                        0: {
                            items: 1,
                        },
                        480: {
                            items: 2,
                        },
                        768: {
                            items: 3,
                        },
                        1024: {
                            items: 4,
                        },
                    },
                });
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.ids}`);
                this.recommends = response.data.data;
                this.isLoading = false;

                // 等待 DOM 完全更新後再初始化 OwlCarousel
                this.$nextTick(() => {
                    // this.initOwlCarousel();
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner-border {
    margin: 0 50%;
}
</style>
